import React, { useState, useEffect } from 'react';
import AdminLayout from '../components/AdminLayout';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const fmt = (cents) =>
  '$' + (Number(cents || 0) / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });

const card = { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: '16px 20px', marginBottom: 12 };
const empty = (msg) => (
  <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 10, padding: 32, textAlign: 'center', color: '#6b7280', fontSize: 13 }}>{msg}</div>
);

export default function AdminSpending() {
  const [spending, setSpending] = useState([]);
  const [loading, setLoading]   = useState(true);

  const headers = { Authorization: `Bearer ${localStorage.getItem('doorly_admin_token')}` };

  const fetchSpending = async () => {
    try {
      const res = await axios.get(`${API}/api/admin/agents/finance/spending`, { headers });
      setSpending(res.data || []);
    } catch (err) {
      console.error('Spending fetch failed:', err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchSpending(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Scale the bars to the widest category in the period.
  const spendMax = spending.reduce((m, s) => Math.max(m, Number(s.total_cents || 0)), 0) || 1;

  return (
    <AdminLayout>
      <div style={{ padding: '24px 32px' }}>
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 2 }}>Finance</div>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: '#111827', margin: 0 }}>Spending Analysis</h1>
        </div>

        {loading && <div style={{ color: '#6b7280', fontSize: 13, padding: 20 }}>Loading…</div>}

        {!loading && spending.length === 0 && empty('No outbound spend in the last 90 days')}
        {!loading && spending.length > 0 && (
          <div style={card}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 12 }}>
              Operating spend by category · last 90 days
            </div>
            {spending.map(s => (
              <div key={s.category} style={{ marginBottom: 12 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 4 }}>
                  <span style={{ color: '#374151', fontWeight: 600 }}>{s.category || 'Uncategorized'}</span>
                  <span style={{ color: '#111827', fontWeight: 700 }}>{fmt(s.total_cents)} <span style={{ color: '#9ca3af', fontWeight: 400 }}>({s.txn_count})</span></span>
                </div>
                <div style={{ height: 8, borderRadius: 999, background: '#f3f4f6', overflow: 'hidden' }}>
                  <div style={{ width: `${Math.round((Number(s.total_cents) / spendMax) * 100)}%`, height: '100%', background: '#3a6ad9' }} />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
